export function introPin() {
	if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) return
	if (!document.querySelector('.section--intro')) return

	if (!window.matchMedia('(min-width: 64rem)').matches) return

	gsap.timeline({
		scrollTrigger: {
			trigger: '.section--intro',
			pin: true,
			scrub: true,
			start: 'top top',
			end: '+=600',
		},
	})
	.fromTo('.intro__mask', { inset: '0' }, { inset: '-200rem', x: '140vw', opacity: 0, duration: 1 })
	.to('.intro__content', { x: '75vw', opacity: 0, duration: 0.5 }, '<')
}
